import styled from 'styled-components';

export const SectionHeaderContainer = styled.header`
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.colors?.border?.default || '#e2e8f0'};
  padding: 1rem 1.5rem;

  @media (max-width: ${(props) => props.theme.breakpoints?.md || '768px'}) {
    border-bottom: none;
    padding: 1rem;
    padding-top: 0;
  }
`;

export const SectionBodyContainer = styled.div``;
